
import app from '../../App';

export default class SaveQuoteService {
    constructor ( $log, $http, Info) {

        'ngInject';
        this._$http=$http;
        this.Info=Info;
    }

    getFields(){
        return  this._$http({
            method: 'GET',
            url: `https://api.hubapi.com/forms/v2/fields/3ff321c2-df2b-4c15-8c16-21c9789988d0?hapikey=${this.Info.hubspotApiKey}`
        });
    }

    saveQuote(name='',email='',phone='',url='',plan='monthly',displays=0,devices=0,planRate=0){
        return  this._$http({
            method: 'POST',
            url: `${this.Info.host}v1/autobilling/submithubspotform`,
            // url: `https://forms.hubspot.com/uploads/form/v2/${this.Info.hubspotPortalId}/3ff321c2-df2b-4c15-8c16-21c9789988d0`,
            data: {
                FormGuid:'3ff321c2-df2b-4c15-8c16-21c9789988d0',
                Fields: [
                    {"Name":"firstname", "Value": (name.split(" ").length>1)?name.split(" ")[0]:name},
                    {"Name":"lastname", "Value":(name.split(" ").length>1)?name.split(" ").slice(1).join(" "):''},
                    {"Name":"email", "Value":email},
                    {"Name":"phone", "Value":phone},
                    {"Name":"message", "Value":''},
                    {"Name":"calculator_plan_name", "Value":plan},
                    {"Name":"calculator_annual_or_monthly_selected", "Value":plan},
                    {"Name":"calculator_licenses", "Value":displays},
                    {"Name":"calculator_devices", "Value":devices},
                    {"Name":"calculator_checkout_link", "Value":url},
                    {"Name":"calculator_plan_rate", "Value":planRate}
                ]
            },
            // transformRequest: function(obj) {
            //     var str = [];
            //     for(var p in obj)
            //         if(encodeURIComponent(obj[p])!='')
            //             str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            //     console.log(str.join("&"));
            //     return str.join("&");
            // },
            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded'
            // }
        });
    }
};

app.service( 'SaveQuoteService', SaveQuoteService );


// WEBPACK FOOTER //
// ./src/js/services/checkout-flow/SaveQuoteService.js